var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Card, CardContent, Typography, Box, alpha } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
const StyledCard = styled(Card, {
    shouldForwardProp: (prop) => prop !== "selected" && prop !== "clickable",
})(({ theme, selected, clickable }) => ({
    cursor: clickable ? "pointer" : "default",
    border: selected ? "none" : "1px solid #919EAB33",
    borderRadius: theme.spacing(4),
    backgroundColor: selected
        ? theme.palette.primary.main
        : theme.palette.background.paper,
    color: selected
        ? theme.palette.primary.contrastText
        : theme.palette.text.primary,
    "&:hover": clickable
        ? {
            backgroundColor: selected
                ? alpha(theme.palette.primary.main, 0.85)
                : alpha(theme.palette.grey[200], 0.04),
        }
        : {},
    "&:active": clickable
        ? {
            backgroundColor: selected
                ? alpha(theme.palette.primary.main, 0.9)
                : theme.palette.grey[200],
        }
        : {},
}));
const StatsCard = (_a) => {
    var { title, value, subtitle, selected, onClick, variant, sx } = _a, rest = __rest(_a, ["title", "value", "subtitle", "selected", "onClick", "variant", "sx"]);
    return (React.createElement(StyledCard, Object.assign({ selected: selected, clickable: Boolean(onClick), onClick: onClick, sx: sx }, rest),
        React.createElement(CardContent, { sx: { px: 2.5, py: 2 } },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "body1", color: "inherit" }, title),
                React.createElement(Typography, { variant: "subtitle1", mt: 1, color: "inherit" }, value),
                subtitle && (React.createElement(Typography, { variant: "body2", color: "inherit", sx: { opacity: 0.72 } }, subtitle))))));
};
export const FCard = (_a) => {
    var { variant = "default" } = _a, props = __rest(_a, ["variant"]);
    if (variant === "stats") {
        return React.createElement(StatsCard, Object.assign({}, props));
    }
    const { children, selected, onClick, title, value, subtitle, sx } = props, rest = __rest(props, ["children", "selected", "onClick", "title", "value", "subtitle", "sx"]);
    return (React.createElement(StyledCard, Object.assign({ selected: selected, clickable: Boolean(onClick), onClick: onClick, sx: sx }, rest), children));
};
export { MobileCard } from "./MobileCard";
